import { formatRelativeTime } from '../lib/format';

interface DraftNoticeProps {
  /** ISO time the recovered draft was written. */
  savedAt: string;
  /**
   * What was put back, in the caller's words. The write time is appended to it,
   * so it reads as the opening of one sentence.
   */
  message?: string;
  onDismiss: () => void;
  /** Verb-first label for the optional discard action. */
  discardLabel?: string;
  /** Omit when the form already has a cancel that throws the draft away. */
  onDiscard?: () => void;
}

/**
 * Recovered-work sliver: unsaved input was found and put back on screen.
 *
 * A sliver of a ticket rather than a ticket — amber, because this is work in
 * progress, not a pass or a failure. The write time is the only thing set in
 * mono, because it is the only real data on the strip.
 */
export function DraftNotice({
  savedAt,
  message = 'Draft restored from',
  onDismiss,
  discardLabel = 'Discard draft',
  onDiscard,
}: DraftNoticeProps) {
  return (
    <div className="draft-notice" role="status">
      <p className="draft-notice__message">
        {message} <span className="draft-notice__stamp">{formatRelativeTime(savedAt)}</span>
      </p>
      {onDiscard ? (
        <button
          className="button button--ghost draft-notice__action"
          type="button"
          onClick={onDiscard}
        >
          {discardLabel}
        </button>
      ) : null}
      <button
        className="draft-notice__close"
        type="button"
        aria-label="Dismiss draft notice"
        onClick={onDismiss}
      >
        ×
      </button>
    </div>
  );
}
